module.exports = __webpack_public_path__ + "static/logo-dbc2a974e15fd5b2be2ce85a04b6bbaf.svg";